<template>
  <v-card v-if="quote.instructed != 0">
    <v-card-text>
      <h2><v-icon>assignment_ind</v-icon>Details</h2>
      <div v-if="clients">
        <strong>Clients</strong>&#160;
        <span v-for="client in clients" :key="client.id">
          <EntityZ :entity="client" />&#160;
        </span>
        <hr />
      </div>
      <template v-if="selectedHeaderElement != 3">
        <v-layout row>
          <v-flex xs12 md3>
            <strong>Name</strong>
          </v-flex>
          <v-flex xs12 md9>{{ quote.name }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md3>
            <strong>Telephone</strong>
          </v-flex>
          <v-flex xs12 md9>{{ quote.telephone }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md3>
            <strong>Address</strong>
          </v-flex>
          <v-flex xs12 md9 style="white-space: pre-wrap">{{
            quote.address
          }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md3>
            <strong>Internal note</strong>
          </v-flex>
          <v-flex xs12 md9 style="white-space: pre-wrap">{{
            quote.note
          }}</v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md3>
            <strong>GDPR Agreed</strong>
          </v-flex>
          <v-flex xs12 md9>{{ quote.gdpr }}</v-flex>
        </v-layout>
        <v-btn @click="$emit('changeSelectedHeaderElement', 3)" small>
          <v-icon>edit</v-icon>Edit details
        </v-btn>
      </template>
      <template v-if="selectedHeaderElement == 3">
        <div>
          <v-text-field label="Name" v-model="quoteCopy.name" box />
          <v-text-field label="Telephone" v-model="quoteCopy.telephone" box />
          <v-textarea label="Address" v-model="quoteCopy.address" box auto-grow>
            <template slot="append">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon @click="shown = true" v-on="on">search</v-icon>
                </template>
                <span>Search for an address</span>
              </v-tooltip>
            </template>
          </v-textarea>
          <div class="ajaxForm" v-if="shown">
            <Postcode @changeAddress="changeAddress" />
            <hr />
            <v-btn @click="shown = false">Cancel</v-btn>
          </div>
          <v-textarea
            label="Internal note"
            v-model="quoteCopy.note"
            box
            auto-grow
          />
          <v-checkbox label="GDPR Agreed" v-model="quoteCopy.gdpr" />
          <v-btn @click="updateDetails"> <v-icon>save</v-icon>Save </v-btn>
          <v-btn @click="$emit('changeSelectedHeaderElement', 0)">
            <v-icon>undo</v-icon>Cancel
          </v-btn>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import EntityZ from "@/components/link/EntityZ";
import Postcode from "@/components/layout/Postcode";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Details",
  props: ["quote", "lastUpdated", "selectedHeaderElement"],
  components: { EntityZ, Postcode },
  data() {
    return { clients: null, shown: false, quoteCopy: null };
  },
  methods: {
    async fetchClients() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/quotes/${this.$route.params.id}/clients`
      );
      // console.log(response.data);
      this.clients = response.data;
    },
    async updateDetails() {
      await nbmlaw.put(
        `/cors/admin/sales/quotes/${this.$route.params.id}`,
        this.quoteCopy
      );
      // console.log(response.data);
      this.$emit("changeSelectedHeaderElement", 0);
    },
    async changeAddress(id) {
      if (confirm("Are you sure?")) {
        const response = await nbmlaw.get(`/cors/admin/directory/loqate/${id}`);
        // console.log(response.data);
        this.quoteCopy.address = response.data;
        this.shown = false;
      }
    }
  },
  watch: {
    lastUpdated: {
      immediate: true,
      handler() {
        this.fetchClients();
        this.quoteCopy = JSON.parse(JSON.stringify(this.quote));
      }
    }
  }
};
</script>